var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"overlay-loader"},[_c('img',{attrs:{"src":require("../assets/img/ajax-loader.gif"),"alt":"loading data..."}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }